module.exports = __webpack_public_path__ + "img/norecord.bfea4ced.png";